import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=a0bd2eac&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=a0bd2eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bd2eac",
  null
  
)

export default component.exports